'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LazyComponent = ({
  children,
  debounce = 0
}) => {
  const ref = React__default["default"].useRef(null);
  const [hydrated, setHydrated] = React.useState(false);
  React__default["default"].useEffect(() => {
    if (!ref.current)
      return;
    const ob = new IntersectionObserver((entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setHydrated(true);
          observer.disconnect();
          return;
        }
      }
    });
    ob.observe(ref.current);
    function hydrate(deadline) {
      if (deadline.timeRemaining() > debounce) {
        setHydrated(true);
        ob.disconnect();
      } else {
        requestIdleCallback(hydrate);
      }
    }
    if (debounce > 0) {
      requestIdleCallback(hydrate);
    }
    return () => ob.disconnect();
  }, [debounce]);
  return /* @__PURE__ */ jsxRuntime.jsx("div", {
    ref,
    className: "lazy-component",
    children: hydrated ? children : /* @__PURE__ */ jsxRuntime.jsx("div", {
      className: "fake-body",
      style: { width: "100%", height: 200 }
    })
  });
};

exports.LazyComponent = LazyComponent;
